export default __webpack_public_path__ + "static/media/loading0.041a8d55.gif";